import styled from 'styled-components';
import {BGImageCenter, getStaticImage} from '../../../../globalVariables/GlobalVariables';
import * as pricingPopCss from '../pricingPop/PricingPop.css';

const pricingGroupImage = getStaticImage('subscriptions/pricesGroupForm.png');

export const pricingGroupPop = styled(pricingPopCss.pricingPop)``;

export const header = styled(pricingPopCss.header)`
    ${BGImageCenter(pricingGroupImage, '160px auto')}
    background-position-y: bottom;
`;

export const content = styled(pricingPopCss.content)``;

